import { getSelectedDates, convert_date_to_timestamp, get_days } from './dates'


export function updateFilterUrl(activeFilters, currentPage, filterView){
  let filterUrl = '';
  let count = 0;
  let page = 0;
  for (const filter_name in activeFilters) {
    const filter = activeFilters[filter_name],
          filter_values = filter.value.toString();

    if (filter_values.length){
      if (count > 0){
        filterUrl += '&';
      } else {
        filterUrl += '#';
      }
      filterUrl += filter_name + '=' + filter_values;

      count += 1;

    }
  }
  if (count > 0){
    filterUrl += '&page=' + currentPage;
    filterUrl += '&view=' + filterView;

  } else {
    filterUrl += '#page=' + currentPage;
    filterUrl += '&view=' + filterView;
  }
  window.history.pushState(null, null, filterUrl);
}


export function parseFilterUrl(filterForm, filterSettings){
  let hash =  window.location.hash;

  if (typeof filterForm != "undefined"){
    filterForm.forEach((widget) => {
      widget.filters.forEach((filter) => {

        let value = [];
        if (filter.name == "search"){
          value = "";
        }
        if (filter.name == "calendar"){
          value = [false, false];
        }

        const activeFilter = {
          position: 'side',
          type: filter.type,
          name: filter.name,
          title: filter.title,
          value: value,
          selectedTitles: [],
          or: filter.or
        }
        filterSettings.activeFilters[filter.name] = activeFilter;
      })
    });


  }

  filterSettings.showTags = true;




  if (!hash.length)
    return filterSettings;

  let params = hash.split("#")[1].split("&");
  params.forEach((param, i)=> {
    const v = param.split("=");
    if (v[0] == "page") {
      filterSettings.pagination.currentPage = v[1];
    } else if (v[0] == "view") {
      filterSettings.currentView = v[1];
    } else {


      if (filterSettings.activeFilters[v[0]]){

        let value = [];
        value = v[1].split(',');
        if (v[0] == "search" ){
          value = decodeURI(v[1]);
          filterSettings.activeFilters[v[0]].value = value;

          if (value.length > 1){
     
            let search_input = document.getElementById('events-search');
          
 

            if (search_input != null){
              search_input.value = value;

            }



          }


        } else if (v[0] == "calendar" ){
          if (value.length < 2){
            value = value[0].split('%2C');
          }

          let start_date = decodeURI(value[0]),
              end_date = decodeURI(value[1]);


          if (start_date != 'false'){
            start_date = new Date(new Date(start_date).setHours(0,0,0,0));
          } else {
            start_date = false;
          }

          if (end_date != "false"){
            end_date = new Date(new Date(end_date).setHours(0,0,0,0));
          } else {
            end_date = false;
          }

          filterSettings.activeFilters[v[0]].value = [start_date, end_date];

        } else if (v[0] == "top_filter"){
          if (filterSettings.activeFilters[v[0]].type == "date" && v[1] !== "all"){
            filterSettings.activeFilters[v[0]].value = parseInt(v[1]);

          } else {
            filterSettings.activeFilters[v[0]].value = v[1];

          }



        } else {


          filterSettings.activeFilters[v[0]].value = value;
          //need to do it this way to maintain correct order. will need to be optimised
          let selectedTitles = [];
          if (typeof value != "undefined"){
            value.forEach((v) => {

              filterForm.forEach((widget) => {
                if (typeof widget.filters != "undefined"){
                  let filters = widget.filters;

                  filters.forEach((filter) => {

                    if (typeof filter.elements != "undefined" && filter.elements.length){
                      let elements = filter.elements;
                      elements.forEach((element) => {
                        if (v == element.value){
                          selectedTitles.push(element.title);

                        }
                      })
                    }


                  })
                }

              })
            })
          }


          filterSettings.activeFilters[v[0]].selectedTitles = selectedTitles;
        }




      }

    }
  });
  return filterSettings;
}
